import type {
  VideoClipPipPosition,
  VideoClipPipShape,
  VideoClipPipSize,
} from "@circle-react/components/shared/VideoClipRecorder/hooks/useVideoClipSettingsStore";
import { useVideoClipContext } from "@circle-react/components/shared/VideoClipRecorder/VideoClipContext";
import { SegmentedControl } from "@circleco/compass/components/SegmentedControl";

import { t } from "@/i18n-js/instance";

import {
  PIP_POSITION_OPTIONS,
  PIP_SHAPE_OPTIONS,
  PIP_SIZE_OPTIONS,
} from "./constants";
import { SettingsSection } from "./SettingsSection";
import { buildOptions, handleSegmentChange } from "./utils";

interface ScreenShareSettingsPopoverProps {
  onSelectPipPosition: (pipPosition: VideoClipPipPosition) => void;
  onSelectPipShape: (pipShape: VideoClipPipShape) => void;
  onSelectPipSize: (pipSize: VideoClipPipSize) => void;
}

export const ScreenShareSettingsPopover = ({
  onSelectPipPosition,
  onSelectPipShape,
  onSelectPipSize,
}: ScreenShareSettingsPopoverProps) => {
  const { pipPosition, pipShape, pipSize } = useVideoClipContext();

  return (
    <div className="w-[300px] max-w-[calc(100vw-3rem)] py-1.5">
      <SettingsSection title={t("tiptap.video_clip.settings.pip_shape.label")}>
        <SegmentedControl
          fullWidth
          required
          options={buildOptions(PIP_SHAPE_OPTIONS)}
          value={pipShape}
          onValueChange={handleSegmentChange(
            PIP_SHAPE_OPTIONS,
            onSelectPipShape,
          )}
        />
      </SettingsSection>
      <SettingsSection title={t("tiptap.video_clip.settings.pip_size.label")}>
        <SegmentedControl
          fullWidth
          required
          options={buildOptions(PIP_SIZE_OPTIONS)}
          value={pipSize}
          onValueChange={handleSegmentChange(PIP_SIZE_OPTIONS, onSelectPipSize)}
        />
      </SettingsSection>
      <SettingsSection
        title={t("tiptap.video_clip.settings.pip_position.label")}
      >
        <SegmentedControl
          fullWidth
          required
          options={buildOptions(PIP_POSITION_OPTIONS)}
          value={pipPosition}
          onValueChange={handleSegmentChange(
            PIP_POSITION_OPTIONS,
            onSelectPipPosition,
          )}
        />
      </SettingsSection>
    </div>
  );
};
